<template>
  <ul>
    <li class="dropdown-item">
      <router-link :to="addToQuery({ page: 1, parent_id: folder.id, 'filters[ocr_content_present]': true })" class="dropdown-item">
        {{ $t('root.filters.yes_extracted') }}
      </router-link>
    </li>
    <li class="dropdown-item">
      <router-link :to="addToQuery({ page: 1, parent_id: folder.id, 'filters[ocr_content_present]': false })" class="dropdown-item">
        {{ $t('root.filters.no_extracted') }}
      </router-link>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      folder: {
        type: Object,
        required: true,
      },
    }
  }
</script>
